import { createFileRoute } from '@tanstack/react-router'
import { getNewsPage } from '~/lib/content/content'
import { cacheHeaders } from '~/lib/site/cache'
import { newsHead, validateNewsSearch } from '~/lib/news/routes'
import { NewsListing } from '~/components/sections/NewsListing'

// "All" tab. Page 1 is prerendered; later pages are fetched after hydration
// from data/news/<hash>/<type>/<page>.json (see vite.config.ts).
export const Route = createFileRoute('/news/')({
  validateSearch: validateNewsSearch,
  loader: () => getNewsPage({ data: { type: 'all', page: 1 } }),
  headers: () => cacheHeaders.content,
  head: () => newsHead('News'),
  component: NewsAll,
})

function NewsAll() {
  const { page, q } = Route.useSearch()
  return (
    <NewsListing
      type="all"
      page={page ?? 1}
      q={q}
      initial={Route.useLoaderData()}
    />
  )
}
